const country: any = {
    'AF': 'AFN',
    'AX': 'EUR',
    'AL': 'ALL',
    'DZ': 'DZD',
    'AS': 'USD',
    'AD': 'EUR',
    'AO': 'AOA',
    'AI': 'XCD',
    'AQ': 'USD',
    'AG': 'XCD',
    'AR': 'ARS',
    'AM': 'AMD',
    'AW': 'AWG',
    'AC': 'SHP',
    'AU': 'AUD',
    'AT': 'EUR',
    'AZ': 'AZN',
    'BS': 'BSD',
    'BH': 'BHD',
    'BD': 'BDT',
    'BB': 'BBD',
    'BY': 'BYN',
    'BE': 'EUR',
    'BZ': 'BZD',
    'BJ': 'XOF',
    'BM': 'BMD',
    'BT': 'INR',
    'BO': 'BOB',
    'BA': 'BAM',
    'BW': 'BWP',
    'BV': 'NOK',
    'BR': 'BRL',
    'IO': 'USD',
    'VG': 'USD',
    'BN': 'BND',
    'BG': 'BGN',
    'BF': 'XOF',
    'BI': 'BIF',
    'KH': 'KHR',
    'CM': 'XAF',
    'CA': 'CAD',
    'IC': 'EUR',
    'CV': 'CVE',
    'KY': 'KYD',
    'CF': 'XAF',
    'TD': 'XAF',
    'CL': 'CLP',
    'CN': 'CNY',
    'CX': 'AUD',
    'CC': 'AUD',
    'CO': 'COP',
    'KM': 'KMF',
    'CG': 'XAF',
    'CD': 'CDF',
    'CK': 'NZD',
    'CR': 'CRC',
    'CI': 'XOF',
    'HR': 'HRK',
    'CU': 'CUP',
    'CW': 'ANG',
    'CY': 'EUR',
    'CZ': 'CZK',
    'DK': 'DKK',
    'DJ': 'DJF',
    'DM': 'XCD',
    'DO': 'DOP',
    'TL': 'IDR',
    'EC': 'USD',
    'EG': 'EGP',
    'SV': 'SVC',
    'GQ': 'XAF',
    'ER': 'ERN',
    'EE': 'EUR',
    'ET': 'ETB',
    'FK': 'FKP',
    'FO': 'DKK',
    'FJ': 'FJD',
    'FI': 'EUR',
    'FR': 'EUR',
    'GF': 'EUR',
    'PF': 'XPF',
    'TF': 'EUR',
    'GA': 'XAF',
    'GM': 'GMD',
    'GE': 'GEL',
    'DE': 'EUR',
    'GH': 'GHS',
    'GI': 'GIP',
    'GR': 'EUR',
    'GL': 'DKK',
    'GD': 'XCD',
    'GP': 'EUR',
    'GU': 'USD',
    'GT': 'GTQ',
    'GG': 'GBP',
    'GN': 'GNF',
    'GW': 'XOF',
    'GY': 'GYD',
    'HT': 'HTG',
    'HM': 'AUD',
    'HN': 'HNL',
    'HK': 'HKD',
    'HU': 'HUF',
    'IS': 'ISK',
    'IN': 'INR',
    'ID': 'IDR',
    'IR': 'IRR',
    'IQ': 'IQD',
    'IE': 'EUR',
    'IM': 'GBP',
    'IL': 'ILS',
    'IT': 'EUR',
    'JM': 'JMD',
    'JP': 'JPY',
    'JE': 'GBP',
    'JO': 'JOD',
    'KZ': 'KZT',
    'KE': 'KES',
    'KI': 'AUD',
    'XK': 'EUR',
    'KW': 'KWD',
    'KG': 'KGS',
    'LA': 'LAK',
    'LV': 'EUR',
    'LB': 'LBP',
    'LS': 'LSL',
    'LR': 'LRD',
    'LY': 'LYD',
    'LI': 'CHF',
    'LT': 'EUR',
    'LU': 'EUR',
    'MO': 'MOP',
    'MK': 'MKD',
    'MG': 'MGA',
    'MW': 'MWK',
    'MY': 'MYR',
    'MV': 'MVR',
    'ML': 'XOF',
    'MT': 'EUR',
    'MH': 'USD',
    'MQ': 'EUR',
    'MR': 'MRU',
    'MU': 'MUR',
    'YT': 'EUR',
    'MX': 'MXN',
    'FM': 'USD',
    'MD': 'MDL',
    'MC': 'EUR',
    'MN': 'MNT',
    'ME': 'EUR',
    'MS': 'XCD',
    'MA': 'MAD',
    'MZ': 'MZN',
    'MM': 'MMK',
    'NA': 'NAD',
    'NR': 'AUD',
    'NP': 'NPR',
    'NL': 'EUR',
    'AN': 'ANG',
    'NC': 'XPF',
    'NZ': 'NZD',
    'NI': 'NIO',
    'NE': 'XOF',
    'NG': 'NGN',
    'NU': 'NZD',
    'NF': 'AUD',
    'KP': 'KPW',
    'MP': 'USD',
    'NO': 'NOK',
    'OM': 'OMR',
    'PK': 'PKR',
    'PW': 'USD',
    'PS': 'JOD',
    'PA': 'PAB',
    'PG': 'PGK',
    'PY': 'PYG',
    'PE': 'PEN',
    'PH': 'PHP',
    'PN': 'NZD',
    'PL': 'PLN',
    'PT': 'EUR',
    'PR': 'USD',
    'QA': 'QAR',
    'RE': 'EUR',
    'RO': 'RON',
    'RU': 'RUB',
    'RW': 'RWF',
    'BL': 'EUR',
    'SH': 'GBP',
    'KN': 'XCD',
    'LC': 'XCD',
    'MF': 'EUR',
    'PM': 'EUR',
    'VC': 'XCD',
    'WS': 'WST',
    'SM': 'EUR',
    'ST': 'STN',
    'SA': 'SAR',
    'SN': 'XOF',
    'RS': 'RSD',
    'CS': 'RSD',
    'SC': 'SCR',
    'SL': 'SLL',
    'SG': 'SGD',
    'SX': 'ANG',
    'SK': 'EUR',
    'SI': 'EUR',
    'SB': 'SBD',
    'SO': 'SOS',
    'ZA': 'ZAR',
    'GS': 'GBP',
    'KR': 'KRW',
    'SS': 'SSP',
    'ES': 'EUR',
    'LK': 'LKR',
    'SD': 'SDG',
    'SR': 'SRD',
    'SJ': 'NOK',
    'SZ': 'SZL',
    'SE': 'SEK',
    'CH': 'CHF',
    'SY': 'SYP',
    'TW': 'TWD',
    'TJ': 'TJS',
    'TZ': 'TZS',
    'TH': 'THB',
    'TG': 'XOF',
    'TK': 'NZD',
    'TO': 'TOP',
    'TT': 'TTD',
    'TA': 'SHP',
    'TN': 'TND',
    'TR': 'TRY',
    'TM': 'TMT',
    'TC': 'USD',
    'TV': 'AUD',
    'UM': 'USD',
    'VI': 'USD',
    'UG': 'UGX',
    'UA': 'UAH',
    'AE': 'AED',
    'GB': 'GBP',
    'US': 'USD',
    'UY': 'UYU',
    'UZ': 'UZS',
    'VU': 'VUV',
    'VA': 'EUR',
    'VE': 'VES',
    'VN': 'VND',
    'WF': 'XPF',
    'EH': 'MAD',
    'YE': 'YER',
    'ZM': 'ZMW',
    'ZW': 'ZWL',
};

const v = {
    country
};

export default v;